// Run this example by adding <%= javascript_pack_tag 'schedule' %> to the head of your layout file

import React from 'react'
import ReactDOM from 'react-dom'

import Schedule from '../schedule/Schedule'

const root = document.getElementById('schedule')
const bucket = root.dataset.bucket
const buckets = root.dataset.buckets
const screening = root.dataset.screening
const path = root.dataset.path
const title = root.dataset.title
const festival = root.dataset.festival
const view = root.dataset.view

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(
    <Schedule
      bucket={bucket}
      buckets={buckets}
      screeningId={screening}
      festival={festival}
      path={path}
      title={title}
      defaultView={view}
    />,
    root,
  )
})
